<script>
	import { Icon } from '@shopboxai/sb-portal-components';
	export let customProducts = [];
	let currentProduct = '';

	const parseToSku = (url) => {
		let sku = '';
		let skuArr = url
			.split('?')[0]
			.split('/')
			.filter((x) => x != '');
		sku = skuArr[skuArr.length - 1]
			.replace('.html', '')
			.replace('.aspx', '')
			.replace('.asp', '')
			.replace(/^.*\/\/[^/]+/, '')
			.replace(/[^\w]/g, '')
			.replace(/_/g, '');

		return sku;
	};
	const addProduct = () => {
		let newProduct = {};
		newProduct.url = currentProduct;
		newProduct.sku = parseToSku(newProduct.url);
		customProducts = [newProduct, ...customProducts];
		currentProduct = '';
	};
	const removeProduct = (url) => {
		customProducts = customProducts.filter((p) => p.url !== url);
		console.log('remove', url);
	};
</script>

<div class="custom-products-wrapper">
	<form on:submit|preventDefault={addProduct}>
		<input
			class="primary"
			placeholder="Enter product url"
			type="text"
			bind:value={currentProduct}
		/>
		<button class="primary" style="height:100%;" type="submit">Add </button>
	</form>
	{#if customProducts.length > 0}
		<h4>Product list:</h4>
	{/if}

	<ul>
		{#each customProducts as product (product.url)}
			<li>
				<span class="product-url">{product.sku}</span>
				<button class="secondary" on:click={() => removeProduct(product.url)}
					><Icon name="close" /></button
				>
			</li>
		{/each}
	</ul>
</div>

<style>
	form {
		display: flex;
	}
	ul,
	li,
	input {
		width: 100%;
	}
	ul {
		padding: 0;
	}
	li {
		display: flex;
		align-items: center;
		justify-content: space-between;
		border-bottom: 1px solid var(--br-c);
		margin-bottom: 4px;
	}
	span {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		max-width: 300px;
	}
	button {
		padding: 0;
	}
</style>
